module.exports = __webpack_public_path__ + "static/images/styles/images/nations/italy.27db44c8.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/italy.png
// module id = 3666
// module chunks = 11